import React from 'react';
import SNavbar from '../components/Navbar';
import { useSelector } from 'react-redux';

function Index({child}) {
  const user = useSelector((state) => state.auth);

  return (
    <>
    <div className='d-flex flex-column flex-root app-root'>
        <div className='app-page flex-column flex-column-fluid'>
            <SNavbar user={user}/>
            {child}
        </div>
    </div>
    </>
  )
}

export default Index